import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import localForage from 'localforage';

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_URL}/graphql`,
});

export const wsLink = new WebSocketLink({
  uri: `${process.env.REACT_APP_SOCKET_PROTOCOL}://${process.env.REACT_APP_API_URL}/graphql`,
  options: {
    lazy: true,
    reconnect: true,
    connectionParams: async () => {
      const token = await localForage.getItem('@token');

      return {
        authorization: `${token}`,
      };
    },
  },
});

let isNotificationSet = false;

const authLink = setContext(async (__, { headers }) => {
  const token = await localForage.getItem('@token');

  if (token && !isNotificationSet) {
    // initPushNotification();
    isNotificationSet = true;
  }

  const url = process.env.REACT_APP_API_URL + `/graphql`;
  // set up the url for websocket
  // wsLink.subscriptionClient.url = `${process.env.REACT_APP_SOCKET_PROTOCOL}://` + url;

  const extraOptions = token ? { authorization: `${token}` } : {};
  return {
    uri: `${process.env.REACT_APP_API_PROTOCOL}://` + url,
    headers: {
      ...headers,
      ...extraOptions,
    },
  };
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);

    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  authLink.concat(httpLink)
);

const cache = new InMemoryCache({
  // @ts-ignore
  dataIdFromObject: (o) => (o._id ? `${o.__typename}${o._id}` : o._id),
  typePolicies: {
    Query: {
      fields: {
        chats: {
          keyArgs: ['searchString', 'type'],
          // Concatenate the incoming list items with
          // the existing list items.
          merge(existing = [], incoming, { args: { offset } }) {
            return offset ? [...existing, ...incoming] : incoming;
          },
        },
      },
    },
  },
});

export const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
  fetchOptions: {
    mode: 'no-cors',
  },
});
